// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#all-received-sendOuts .stickyNavbar[data-v-5c8fca3d] {\n  padding-bottom: 5px !important;\n}\n#all-received-sendOuts .stickyNavbar .container-default[data-v-5c8fca3d] {\n  padding-top: 0;\n  padding-bottom: 5px;\n}", ""]);
// Exports
module.exports = exports;
